export default {
  flashSalesWarningIneligibilityCta: {
    id: 'flash_sales_cart_cta_remove',
    defaultMessage: 'Remove items',
  },
  flashSalesWarningNotAppliedTitle: {
    id: 'flash_sales_cart_warning_title',
    defaultMessage: 'Flash Sale not applied',
  },
  flashSalesWarningIneligibleTitle: {
    id: 'flash_sales_modal_cart_warning_ineligibility_title',
    defaultMessage: 'Remove items to get Flash Sale',
  },
  flashSalesWarningInactive: {
    id: 'flash_sales_cart_promotion_inactive_subtitle',
    defaultMessage: "The promotion isn't activated yet",
  },
  flashSalesWarningEnded: {
    id: 'flash_sales_cart_promotion_ended_subtitle',
    defaultMessage: "We couldn't apply it because this promotion is over",
  },
  flashSalesWarningNotStarted: {
    id: 'flash_sales_cart_promotion_not_started_subtitle',
    defaultMessage: "This promotion isn't activated yet",
  },
  flashSalesWarningSoldOut: {
    id: 'flash_sales_modal_cart_warning_stock_description',
    defaultMessage:
      "We couldn't apply the Flash Sale to your cart because we ran out of codes",
  },
  flashSalesWarningIneligible: {
    id: 'flash_sales_cart_ineligible_subtitle',
    defaultMessage: 'Flash Sales can only be used on one order per customer',
  },
  flashSalesWarningQuantityMax: {
    id: 'flash_sales_cart_quantity_exceeds_max_subtitle',
    defaultMessage:
      "We couldn't apply it because the cart maximum has been reached",
  },
  flashSalesWarningQuantityMin: {
    id: 'flash_sales_cart_quantity_below_min_subtitle',
    defaultMessage:
      "We couldn't apply it because the cart minimum hasn't been reached",
  },
  flashSalesWarningIncompatible: {
    id: 'flash_sales_cart_incompatible_text',
    defaultMessage:
      'The following items cannot be combined with Flash Sale items: {product_title}',
  },
}
